// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#proposal-deliverable-fees[data-v-99e708c2] {\n  width: 450px;\n  background-color: var(--v-white-base);\n}\n.label[data-v-99e708c2] {\n  text-align: left;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
